(() => {
  'use strict';

  // Luxury-fast hover: keep it immediate on open, tighten close tolerance.
  // Default in Prestige is 250ms; we tune to 80ms (snappy but not jittery).
  const CLOSE_DELAY_MS = 120;

  function patch(tagName) {
    const Ctor = window.customElements && window.customElements.get(tagName);
    if (!Ctor || !Ctor.prototype) return false;

    try {
      Object.defineProperty(Ctor.prototype, 'mouseOverDelayTolerance', {
        get() { return CLOSE_DELAY_MS; },
        configurable: true
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  function run() {
    // Patch both dropdown and mega menu disclosures (desktop hover trigger).
    const ok1 = patch('dropdown-menu-disclosure');
    const ok2 = patch('mega-menu-disclosure');

    // If theme JS hasn't registered them yet, retry shortly.
    if (!ok1 || !ok2) {
      setTimeout(() => {
        patch('dropdown-menu-disclosure');
        patch('mega-menu-disclosure');
      }, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();